module.exports = {
	"version": "1.2128.2",
	"manifest": {
		"adminLoginButton": "1.2010.8",
		"animations": "1.2080.9",
		"audioCommon": "1.2080.9",
		"audioPlayer": "1.2080.9",
		"backToTopButton": "1.2010.8",
		"backgroundCommon": "1.2108.3",
		"balata": "1.2080.9",
		"bgImageStrip": "1.2108.3",
		"boxSlideShowSlide": "1.2080.9",
		"buttonCommon": "1.2080.9",
		"clipArt": "1.2010.8",
		"column": "1.2108.3",
		"comboBoxInput": "1.2108.3",
		"compDesignUtils": "1.2080.9",
		"compUtils": "1.2080.9",
		"components": "1.2128.2",
		"componentsPreviewLayer": "1.2128.2",
		"contactForm": "1.2080.9",
		"container": "1.2010.8",
		"containerCommon": "1.2010.8",
		"core": "1.2128.2",
		"coreUtils": "1.2108.3",
		"dataFixer": "1.2128.2",
		"datePicker": "1.2108.3",
		"dateUtils": "1.2010.8",
		"deadComponent": "1.2040.17",
		"displayer": "1.2108.3",
		"documentMedia": "1.2080.9",
		"documentServices": "1.2128.2",
		"editingRendererPlugins": "1.2010.8",
		"exitMobileModeButton": "1.2080.9",
		"facebookComments": "1.2080.9",
		"facebookLike": "1.2010.8",
		"facebookLikeBox": "1.2010.8",
		"facebookShare": "1.2108.3",
		"fileUploader": "1.2128.2",
		"flashComponent": "1.2108.3",
		"flickrBadgeWidget": "1.2108.3",
		"fonts": "1.2108.3",
		"fontsPrefetch": "1.2010.8",
		"footerContainer": "1.2010.8",
		"formCommon": "1.2080.9",
		"galleriesCommon": "1.2108.3",
		"googleMap": "1.2080.9",
		"groupContainer": "1.2040.17",
		"headerContainer": "1.2010.8",
		"hoverBox": "1.2108.3",
		"htmlComponent": "1.2108.3",
		"image": "1.2080.9",
		"imageButton": "1.2040.17",
		"imageClientApi": "1.2010.8",
		"imageCommon": "1.2108.3",
		"itunesButton": "1.2108.3",
		"layout": "1.2108.7",
		"linkBar": "1.2080.9",
		"loggingUtils": "1.2108.3",
		"loginButton": "1.2108.3",
		"matrixGallery": "1.2080.9",
		"mediaCommon": "1.2108.6",
		"mediaContainerFactory": "1.2108.3",
		"mediaControls": "1.2108.3",
		"mediaPlayer": "1.2108.3",
		"messageView": "1.2108.3",
		"page": "1.2108.3",
		"paginatedGridGallery": "1.2108.3",
		"paypalButton": "1.2010.8",
		"pinItPinWidget": "1.2080.9",
		"pinterestFollow": "1.2080.9",
		"pinterestPinIt": "1.2010.8",
		"popupCloseTextButton": "1.2108.3",
		"popupContainer": "1.2108.3",
		"previewExtensionsCore": "1.2080.9",
		"qaAutomation": "1.2080.9",
		"radioButton": "1.2108.3",
		"radioGroup": "1.2108.3",
		"render": "1.2128.2",
		"rssButton": "1.2010.8",
		"santaProps": "1.2108.8",
		"screenWidthContainer": "1.2010.8",
		"server": "1.2010.8",
		"singleAudioPlayer": "1.2080.9",
		"siteBackground": "1.2080.9",
		"siteButton": "1.2080.9",
		"siteUtils": "1.2128.2",
		"skinExports": "1.2108.3",
		"skins": "1.2128.2",
		"skypeCallButton": "1.2108.3",
		"slideShowGallery": "1.2080.9",
		"sliderGallery": "1.2080.9",
		"socialCommon": "1.2010.8",
		"soundCloudWidget": "1.2010.8",
		"spotifyFollow": "1.2010.8",
		"spotifyPlayer": "1.2010.8",
		"stripColumnsContainer": "1.2080.9",
		"stripContainer": "1.2080.9",
		"stripSlideShowSlide": "1.2080.9",
		"subscribeForm": "1.2080.9",
		"svgShape": "1.2108.3",
		"testUtils": "1.2128.2",
		"textArea": "1.2108.3",
		"textCommon": "1.2108.3",
		"textInput": "1.2010.8",
		"tinyMenu": "1.2010.8",
		"tpa": "1.2108.9",
		"tpaGalleries": "1.2128.2",
		"translationsUtils": "1.2010.12",
		"tweenEngine": "1.2080.9",
		"twitterFeed": "1.2010.8",
		"utils": "1.2108.3",
		"vKShareButton": "1.2108.3",
		"video": "1.2080.9",
		"wGooglePlusOne": "1.2108.3",
		"wPhoto": "1.2080.9",
		"wRichText": "1.2080.9",
		"wTwitterFollow": "1.2010.8",
		"wTwitterTweet": "1.2108.3",
		"warmup": "1.2128.2",
		"widgets": "1.2108.3",
		"wixCode": "1.2128.2",
		"wixCodeInit": "1.2108.3",
		"wixCodeSeo": "1.2128.2",
		"wixSites": "1.2010.8",
		"wixSkinOnly": "1.2010.8",
		"wixUrlParser": "1.2080.9",
		"wixads": "1.2108.3",
		"wixappsBuilder": "1.2080.9",
		"wixappsClassics": "1.2128.2",
		"wixappsCore": "1.2108.6",
		"youTubeSubscribeButton": "1.2108.3",
		"zoomedImage": "1.2010.8"
	},
	"versions": {
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"tweenmax": "1.19.0",
		"pmrpc": "1.30.0"
	},
	"packages": [
		"adminLoginButton",
		"animations",
		"audioCommon",
		"audioPlayer",
		"backToTopButton",
		"backgroundCommon",
		"balata",
		"bgImageStrip",
		"boxSlideShowSlide",
		"buttonCommon",
		"clipArt",
		"column",
		"comboBoxInput",
		"compDesignUtils",
		"compUtils",
		"components",
		"componentsPreviewLayer",
		"contactForm",
		"container",
		"containerCommon",
		"core",
		"coreUtils",
		"dataFixer",
		"datePicker",
		"dateUtils",
		"deadComponent",
		"displayer",
		"documentMedia",
		"documentServices",
		"editingRendererPlugins",
		"exitMobileModeButton",
		"facebookComments",
		"facebookLike",
		"facebookLikeBox",
		"facebookShare",
		"fileUploader",
		"flashComponent",
		"flickrBadgeWidget",
		"fonts",
		"fontsPrefetch",
		"footerContainer",
		"formCommon",
		"galleriesCommon",
		"googleMap",
		"groupContainer",
		"headerContainer",
		"hoverBox",
		"htmlComponent",
		"image",
		"imageButton",
		"imageClientApi",
		"imageCommon",
		"itunesButton",
		"layout",
		"linkBar",
		"loggingUtils",
		"loginButton",
		"matrixGallery",
		"mediaCommon",
		"mediaContainerFactory",
		"mediaControls",
		"mediaPlayer",
		"messageView",
		"page",
		"paginatedGridGallery",
		"paypalButton",
		"pinItPinWidget",
		"pinterestFollow",
		"pinterestPinIt",
		"popupCloseTextButton",
		"popupContainer",
		"previewExtensionsCore",
		"qaAutomation",
		"radioButton",
		"radioGroup",
		"render",
		"rssButton",
		"santaProps",
		"screenWidthContainer",
		"server",
		"singleAudioPlayer",
		"siteBackground",
		"siteButton",
		"siteUtils",
		"skinExports",
		"skins",
		"skypeCallButton",
		"slideShowGallery",
		"sliderGallery",
		"socialCommon",
		"soundCloudWidget",
		"spotifyFollow",
		"spotifyPlayer",
		"stripColumnsContainer",
		"stripContainer",
		"stripSlideShowSlide",
		"subscribeForm",
		"svgShape",
		"testUtils",
		"textArea",
		"textCommon",
		"textInput",
		"tinyMenu",
		"tpa",
		"tpaGalleries",
		"translationsUtils",
		"tweenEngine",
		"twitterFeed",
		"utils",
		"vKShareButton",
		"video",
		"wGooglePlusOne",
		"wPhoto",
		"wRichText",
		"wTwitterFollow",
		"wTwitterTweet",
		"warmup",
		"widgets",
		"wixCode",
		"wixCodeInit",
		"wixCodeSeo",
		"wixSites",
		"wixSkinOnly",
		"wixUrlParser",
		"wixads",
		"wixappsBuilder",
		"wixappsClassics",
		"wixappsCore",
		"youTubeSubscribeButton",
		"zoomedImage"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/santa-main-r/~/json-loader!./~/santa-main-r/src/main/options/viewer.json
// module id = 24
// module chunks = 0